import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CompanyRate } from 'src/app/modules/companies/_types/company-rate';
import { CompanyRatesService } from 'src/app/modules/companies/_services/companies-rates.service';
import { CompaniesService } from 'src/app/modules/companies/_services/companies.service';
import { ContractsService } from 'src/app/modules/companies/_services/contracts.service';
import { TemplateContracts } from '../../_types/template-contract';
import { TemplatesContractsService } from '../../_services/templates-contracts.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-template-company',
    templateUrl: './template-company.component.html',
    styleUrls: ['./template-company.component.scss'],
    standalone: false
})
export class TemplateCompanyComponent {

  public templateCompanyFormGroup!: RxFormGroup;

  public templateContract: TemplateContracts = new TemplateContracts();
  public companies: any[] = [];
  public contracts: any[] = [];
  public selectedContracts: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private templateCompanyService: TemplatesContractsService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private companiesService: CompaniesService,
    private contractsService: ContractsService,
    private loginService: LoginService
  ) {
    this.templateCompanyFormGroup = this.formBuilder.formGroup<CompanyRate>(this.templateContract) as RxFormGroup;
  }

  ngOnInit(): void {
    if (typeof this.config.data.templateCompanyId != undefined && this.config.data.templateCompanyId != null) {
      this.loadTemplateCompany(this.config.data.templateCompanyId, this.config.data.companyId);
    } else {
      this.templateContract.templateId = this.config.data.templateId;
      this.templateCompanyFormGroup.patchValue(this.templateContract);
  
    }
    this.loadCompanies();

    this.allowWrite = this.loginService.hasPermission("TEMPLATES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TEMPLATES.DELETE");
  }

  async loadTemplateCompany(id: string, companyId?: string ) {

   
    this.templateContract = await firstValueFrom(this.templateCompanyService.get(id));
    if(this.templateContract != null && this.templateContract.contractId != null) this.selectedContracts.push(this.templateContract.contractId);
    if(companyId != null){
      this.selectedContracts = [];
      //buscamos todos los de este template/organization
      let filters = {
        templateId: new Filter(FilterOperation.equals, 'templateId', "", this.templateContract.templateId),
        companyId: new Filter(FilterOperation.equals, 'companyId', "", this.templateContract.companyId)
      };
      let params: IParamsCollection = { }
        //creamos filtros
      params.filter = FilterBuilder.fromObject(filters).build();
      let response = await firstValueFrom(this.templateCompanyService.all(params));
      response.data.forEach((item:any)=>{
        this.selectedContracts.push(item.contractId);
      });      
    }
    this.templateCompanyFormGroup.patchValue(this.templateContract);

    this.loadContracts();
  }

  async loadCompanies() {
    let response = await firstValueFrom(this.companiesService.all());
    this.companies = response.data;
  }

  async loadContracts() {
    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId', "", this.templateCompanyFormGroup.value.companyId)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractsService.all(params));
    this.contracts = response.data;
    if (this.templateCompanyFormGroup.value.contractId == null) this.templateCompanyFormGroup.get('contractId')?.setValue('null');


  }

  async getCompanyTemplate(companyId?: any ){
    let filters = {
      templateId: new Filter(FilterOperation.equals, 'templateId', '', this.templateContract.templateId),
      companyId: new Filter(FilterOperation.equals, 'companyId', '')
    }
    if(companyId != null) filters.companyId.value = companyId;

    let params: IParamsCollection = {
      //page: { size: 1000 },
      filter: FilterBuilder.fromObject(filters).build()
    }
    return await firstValueFrom(this.templateCompanyService.all(params));

  }

  async save() {
    let valid = this.formValidationService.validateForm(this.templateCompanyFormGroup);
    if (valid) {
      this.templateContract = Object.assign(this.templateContract, this.templateCompanyFormGroup.value);
      let success = true;

      //Borramos todos los que estén de esa compañia/template
      if(this.templateContract.companyId != null){
        let actualContractsWithThisCompany = await this.getCompanyTemplate(this.templateContract.companyId);
        if(actualContractsWithThisCompany!=null&&actualContractsWithThisCompany.data.length>0 ){
          let contractsToDelete = actualContractsWithThisCompany.data;
          contractsToDelete.forEach(async (element:any) => {
            await this.templateCompanyService.delete(element.id);     
          });
        }
          //Se añade el nuevo
          if(this.selectedContracts.length== 0){
            let templateC = new TemplateContracts();
            templateC.templateId = this.templateContract.templateId;
            templateC.companyId = this.templateContract.companyId;
            await this.templateCompanyService.save(templateC);
          }else{
            this.selectedContracts.forEach(async (contract:any) => {
              let templateC = new TemplateContracts();
              templateC.contractId = contract;
              templateC.templateId = this.templateContract.templateId;
              templateC.companyId = this.templateContract.companyId;
              await this.templateCompanyService.save(templateC);
            });
          }
      }else{
        //Es que es para TODOS las empresas, así que borramos todas las existentes ya que ahora sólo será el todos.
        let actualCompaniesInThisTemplate = await this.getCompanyTemplate();
        if(actualCompaniesInThisTemplate!=null&&actualCompaniesInThisTemplate.data.length>0 ){
          let contractsToDelete = actualCompaniesInThisTemplate.data;
          contractsToDelete.forEach(async (element:any) => {
            await  this.templateCompanyService.delete(element.id);     
          });
        }
        //Se añade el nuevo
        if(this.selectedContracts.length== 0){
          let templateC = new TemplateContracts();
          templateC.templateId = this.templateContract.templateId;
          await this.templateCompanyService.save(templateC);
        }else{
          this.selectedContracts.forEach(async (contract:any) => {
            let templateC = new TemplateContracts();
            templateC.contractId = contract;
            templateC.templateId = this.templateContract.templateId;
            await this.templateCompanyService.save(templateC);
          });
        }
      }

      if (success) {
        this.messageService.add({ closable: true, severity: 'success', detail: "Compañía aseguradora asignada correctamente." });
        this.dynamicDialogRef.close();
      } else {
        this.messageService.add({ closable: true, severity: 'error', detail: "Error al asignar la compañía aseguradora." });
      }
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
      this.messageService.add({ closable: true, severity: 'error', detail: "Error al asignar la compañía aseguradora." });
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
  
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el contrato de la compañía aseguradora?",
      header: "Desasignar contrato de la compañía aseguradora",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.templateCompanyService.delete(this.templateContract.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Contrato desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
